<main class="reference_form-main">
  <div class="main_container">
    <form [formGroup]="incidentsubcategoryForm">
      <div class="">
        <h3 class="form_name">IncidentSubCategory</h3>


        <div class="input">
          <label for="">IncidentSubCategory Name</label>
          <input type="text" class="default_input reference-form" formControlName="IncidentSubCategoryName" />
        </div>

        <div class="input">
          <label for="">IncidentCategory Id</label>
          <input type="text" class="default_input reference-form" formControlName="IncidentCategoryId" />
        </div>

        <div class="btn_holder">
          <button class="default_primary-button" *ngIf="selectedIndex === null"
            (click)="addNew(incidentsubcategoryForm.value)">Add</button>
          <button class="default_primary-button" *ngIf="selectedIndex !== null"
            (click)="addNew(incidentsubcategoryForm.value)">Update</button>
          <button class="default_secondary-btn ml-2" (click)="onClearForm()">Reset</button>

        </div>

      </div>
    </form>
    <div class="display_table">
      <div class="search_container">
        <input type="text" class="default_input search" placeholder="Search for IncidentSubCategory"
          [formControl]="control" [appAutocomplete]="autocomplete" />
        <em class="ti-search"></em> 

        <app-autocomplete #autocomplete="appAutocomplete">
          <ng-template appAutocompleteContent>
            <ng-container *ngIf="(incidentcategorys | filterReference: control.value) as result">
              <app-option (click)="selectIncidentCategory(option.id)" *ngFor="let option of result"
                [value]="option.IncidentCategoryName">
                {{ option.IncidentCategoryName }}
              </app-option>
              <app-option class="no-result" *ngIf="!result.length">No result...</app-option>
            </ng-container>
          </ng-template>
        </app-autocomplete>
      </div>

      <div class="head">
        <span class="item">S/N</span>
        <span class="item">IncidentSubCategory Name</span>
        <span class="item">IncidentCategory Name</span>
        <span class="item">Action</span>

      </div>

      <div class="scroll">

      </div>
      <div class="body_content" *ngIf="status">
        <div class="the_body"
          *ngFor="let incidentsubcategory of incidentsubcategoryFormArray.get('IncidentSubCategorys')['controls']; index as i"
          (click)="onEdit(i, incidentsubcategory.value)" style="cursor: pointer;" matTooltip="Click to edit"
          aria-label="Button that displays a tooltip when focused or hovered over">
          <span class="content">{{i + 1}}</span>
          <span class="content">{{incidentsubcategory.value.IncidentSubCategoryName}}</span>
          <span class="content">{{incidentsubcategory.value.IncidentCategoryId}}</span>
          <span class="content" (click)="$event.stopImmediatePropagation()">
            <button class="delete_icon trash" (click)="deleteIncidentSubCategory(i, incidentsubcategory.value)">
              <em class="ti-trash"> </em> </button>
          </span>

        </div>
      </div>
      <div class="btn_holder">
        <button class="default_primary-button" (click)="onSubmit(incidentsubcategoryFormArray.value)">Submit</button>
      </div>
    </div>
  </div>
</main>

<div class="box green_box"></div>
<div class="box pink_box"></div>
